import React, {useState} from 'react';
import './App.css';
import AppHeader from "./components/AppHeader";
import HeaderMenus from "./components/HeaderMenus";
import {contentMap} from "./components/menuItems";
import FilterSection from "./components/FilterSection";
import TaskModal, {NewTaskPayload} from "./modals/TaskModal";
import {createTask} from "./features/tasks/tasksSlice";
import {useAppDispatch} from "./hooks";

function App() {

    const [activeKey, setActiveKey] = useState<string>('101');
    const [taskModalOpen, setTaskModalOpen] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    return (
        <div>
            <AppHeader/>
            <HeaderMenus
                onSelect={setActiveKey}
                onCreateTask={() => {
                    setTaskModalOpen(true)
                }}
            />
            <FilterSection/>
            <main className="p-4" style={{
                borderRadius: 4,
                padding: '1rem',
                height: 'calc(100vh - 12.25rem)',
                overflowY: 'scroll',
            }}>
                {contentMap[activeKey] || null}
            </main>

            {/*<HeaderMenus onCreateTask={() => setTaskModalOpen(true)}/>*/}
            <TaskModal
                open={taskModalOpen}
                onCancel={() => setTaskModalOpen(false)}
                onCreated={async (payload: NewTaskPayload) => {
                    await dispatch(createTask(payload)).unwrap(); // ferme la modal si OK
                    // Optionnel: recharger une liste distante, ou laisser la liste locale s’auto-maj (c’est déjà le cas)
                }}
            />
        </div>
    );
}

export default App;